export const CAMPAIGNS = "SET_SEGMENT_EDITOR_CAMPAIGNS";

export const setCampaigns = (campaigns) => {
	return {
		type: CAMPAIGNS,
		campaigns,
	};
};
